import request from '@/utils/request'

export function getVendorList(data) {
  return request({
    url: `/sc-merchant-common/v2/vendor/list/nameBox/excludeSeller`,
    method: 'post',
    data,
  });
}

export function getVendorRuleList(params) {
  return request({
    url: `/sc-sku-standard-processing/size-clean-rule/vendor/drop-down/list`,
    params,
  });
}

export function copyVendorRules(data) {
  return request({
    url: `/sc-basic-merchant-backend/size-clean-rule/vendor/copy`,
    method: 'post',
    data,
  });
}

export function getSizeCleanRuleVendorInfo(vendorId) {
  return request({
    url: '/sc-basic-merchant-backend/size-clean-rule/vendor/base-info',
    params: {
      vendorId,
    },
  });
}

export function getSizeCleanRuleVendorRuleList(params) {
  return request({
    url: '/sc-sku-standard-processing/size-clean-rule/vendor/list',
    params,
  });
}

export function checkSizeCleanRuleVendorFollow(data) {
  return request({
    url: '/sc-sku-standard-processing/size-clean-rule/vendor/follow/check',
    method: 'post',
    data,
  });
}

export function effectSizeCleanRuleVendorFollow(data) {
  return request({
    url: '/sc-sku-standard-processing/size-clean-rule/vendor/follow/effect',
    method: 'post',
    data,
  });
}

export function delSizeCleanRuleVendorRule(data) {
  return request({
    url: '/sc-sku-standard-processing/size-clean-rule/delete',
    method: 'post',
    data,
  });
}

export function recoverSizeCleanRuleVendorRule(data) {
  return request({
    url: '/sc-sku-standard-processing/size-clean-rule/recover',
    method: 'post',
    data,
  });
}

export function giveupSizeCleanRuleVendorRule(data) {
  return request({
    url: '/sc-sku-standard-processing/size-clean-rule/give-up',
    method: 'post',
    data,
  });
}

export function giveupSizeCleanRuleVendorRulesAll(data) {
  return request({
    url: '/sc-sku-standard-processing/size-clean-rule/vendor/give-up/all',
    method: 'post',
    data,
  });
}

export function getFollowVendorList(params) {
  return request({
    url: '/sc-basic-merchant-backend/size-clean-rule/vendor/follow/drop-down/list',
    params,
  });
}

export function executeSizeCleanRuleVendor(data) {
  return request({
    url: '/sc-basic-merchant-backend/size-clean-rule/vendor/execute',
    method: 'post',
    data,
  });
}

export function trialSizeCleanRuleVendor(data) {
  return request({
    url: '/sc-basic-merchant-backend/size-clean-rule/vendor/trial',
    method: 'post',
    data,
  });
}

export function getSizeCleanRulePlatformRuleList(params) {
  return request({
    url: '/sc-sku-standard-processing/size-clean-rule/platform/list',
    params,
  });
}

export function getSizeCleanRuleTemplateList(data) {
  return request({
    url: '/sc-sku-standard-processing/size-clean-rule/template/list',
    method: 'post',
    data,
  });
}

export function getSizeCleanRuleDetail(params) {
  return request({
    url: '/sc-basic-merchant-backend/size-clean-rule/detail',
    params,
  });
}

export function testSizeCleanRule(data) {
  return request({
    url: '/sc-basic-merchant-backend/size-clean-rule/test-rule',
    method: 'post',
    data,
  });
}

export function validationSizeCleanRuleFile(data) {
  return request({
    url: '/sc-basic-merchant-backend/size-clean-rule/file/validation',
    method: 'post',
    data,
  });
}

export function submitSizeCleanRule(data) {
  return request({
    url: '/sc-basic-merchant-backend/size-clean-rule/submit',
    method: 'post',
    data,
  });
}

export function giveupSizeCleanRulePlatformRulesAll(data) {
  return request({
    url: '/sc-sku-standard-processing/size-clean-rule/platform/give-up/all',
    method: 'post',
    data,
  });
}

export function executeSizeCleanRulePlatform(data) {
  return request({
    url: '/sc-basic-merchant-backend/size-clean-rule/platform/execute',
    method: 'post',
    data,
  });
}

export function trialSizeCleanRulePlatform(data) {
  return request({
    url: '/sc-basic-merchant-backend/size-clean-rule/platform/trial',
    method: 'post',
    data,
  });
}

export function getSizeCleanRuleVendorPage(params) {
  return request({
    url: `/sc-basic-merchant-backend/size-clean-rule/index/vendor/page`,
    method: 'get',
    params,
  });
}




export function getAfterCountrySize() {
  return request({
    url: '/sc-basic-merchant-backend/size-clean-rule/product/group/afterCountrySize',
  });
}

export function getSizeCleanRuleProductGroupPage(params) {
  return request({
    url: '/sc-basic-merchant-backend/size-clean-rule/product/group/page',
    params,
  });
}

export function getSizeCleanRuleProductGroupDetail(groupId) {
  return request({
    url: `/sc-basic-merchant-backend/size-clean-rule/product/group/${groupId}`,
  });
}

export function checkSizeCleanRuleProductGroup(data) {
  return request({
    url: `/sc-basic-merchant-backend/size-clean-rule/product/group/check`,
    method: 'post',
    data,
  });
}

export function addSizeCleanRuleProductGroup(data) {
  return request({
    url: `/sc-basic-merchant-backend/size-clean-rule/product/group/add`,
    method: 'post',
    data,
  });
}

export function updateSizeCleanRuleProductGroup(data) {
  return request({
    url: `/sc-basic-merchant-backend/size-clean-rule/product/group/update`,
    method: 'post',
    data,
  });
}

export function deleteSizeCleanRuleProductGroup(data) {
  return request({
    url: `/sc-basic-merchant-backend/size-clean-rule/product/group/delete`,
    method: 'post',
    data,
  });
}

